import { render } from "./SelectedFilters.vue?vue&type=template&id=be6b2df6&scoped=true&ts=true"
import script from "./SelectedFilters.ts?vue&type=script&lang=ts&external"
export * from "./SelectedFilters.ts?vue&type=script&lang=ts&external"

import "./SelectedFilters.scss?vue&type=style&index=0&id=be6b2df6&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6b2df6"]])

export default __exports__